/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Checkout_ErrorInputs */

const en_settings_checkout_error = /** @type {(inputs: Settings_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create checkout session`)
};

const de_settings_checkout_error = /** @type {(inputs: Settings_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Erstellen der Checkout-Sitzung`)
};

const fr_settings_checkout_error = /** @type {(inputs: Settings_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la création de la session de paiement`)
};

const es_settings_checkout_error = /** @type {(inputs: Settings_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al crear la sesión de pago`)
};

const it_settings_checkout_error = /** @type {(inputs: Settings_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile creare la sessione di checkout`)
};

const nl_settings_checkout_error = /** @type {(inputs: Settings_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mislukt om een checkout sessie te maken`)
};

const pl_settings_checkout_error = /** @type {(inputs: Settings_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się utworzyć sesji płatności`)
};

const fi_settings_checkout_error = /** @type {(inputs: Settings_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maksutapahtuman luominen epäonnistui`)
};

const da_settings_checkout_error = /** @type {(inputs: Settings_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke oprette checkout-session`)
};

const sv_settings_checkout_error = /** @type {(inputs: Settings_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misslyckades att skapa kassasession`)
};

/**
* | output |
* | --- |
* | "Failed to create checkout session" |
*
* @param {Settings_Checkout_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_checkout_error = /** @type {((inputs?: Settings_Checkout_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Checkout_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_checkout_error(inputs)
	if (locale === "fr") return fr_settings_checkout_error(inputs)
	if (locale === "es") return es_settings_checkout_error(inputs)
	if (locale === "it") return it_settings_checkout_error(inputs)
	if (locale === "nl") return nl_settings_checkout_error(inputs)
	if (locale === "pl") return pl_settings_checkout_error(inputs)
	if (locale === "fi") return fi_settings_checkout_error(inputs)
	if (locale === "da") return da_settings_checkout_error(inputs)
	if (locale === "sv") return sv_settings_checkout_error(inputs)
	return en_settings_checkout_error(inputs)
});